var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page-wrapper"},[_c('PaymentTravelPKSuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }